<h4 class="redeem-code">{{ "claim-voucher.Redeem" | translate }}</h4>
@if (loaded && versionPaymentPageData && versionPaymentPageData?.prosubDetail?.version_number && versionPaymentOptMsg) {
  <ion-content>
    @if (versionPaymentPageData) {
      <ion-grid style="text-align: center">
        <div [innerHTML]="versionPaymentOptMsg | safeHtml"></div>
      </ion-grid>
    }
    @if (!versionPaymentPageData?.prosubDetail?.hide_voucher_entry_form && versionPaymentPageData) {
      <div>
        <h1 class="voucher-header">{{ "claim-voucher.voucher" | translate }}</h1>
        <ion-row>
          <ion-input [ngClass]="isVoucherIsInvalid$.getValue() ? 'invalid-field' : ''" class="action-btn-large"
            placeholder="{{ versionPaymentPageData?.prosubDetail?.content?.[selectedLanguage]?.textbox_placeholder }}"
            #voucherCode (input)="getButtonStatus($event.target.value)" [value]="vc" class="voucher-input">
          </ion-input>
        </ion-row>

        @if (isVoucherIsInvalid$.getValue()) {
          <ion-row class="voucher-error">
            <p><i class="fas fa-exclamation-triangle"></i> {{ isVoucherIsInvalid$.getValue() }}</p>
          </ion-row>
        }

        <ion-button expand="block" color="secondary" class="checkout-4d-btn" type="submit"
          [disabled]="!voucherCode.value || !isOnline"
          (click)="redeemVoucher(voucherCode.value, false, null); startSpinner()">
          
          @if ((!spinnerAnimation && proceed) || claimFromList) {
            <span>{{ versionPaymentPageData?.prosubDetail?.content?.[selectedLanguage]?.cta_label ?? ("claim-voucher.Redeem_Code" | translate) }}</span>
          }

          @if (!claimFromList) {
            <div>
              @if (spinnerAnimation) {
                <div class="spinners">
                  <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40"></mat-progress-spinner>
                  <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40"></mat-progress-spinner>
                </div>
              }
            </div>
          }

        </ion-button>
      </div>
    }

    @if (versionPaymentPageData?.prosubDetail?.hide_voucher_entry_form && versionPaymentPageData) {
      <ion-button expand="block" color="secondary" class="checkout-4d-btn" type="submit" [disabled]="!isOnline"
        (click)="redeemVoucher(vc, false, null); startSpinner()">
        
        @if ((!spinnerAnimation && proceed) || claimFromList) {
          <span>{{ versionPaymentPageData?.prosubDetail?.content?.[selectedLanguage]?.cta_label ?? ("claim-voucher.Redeem_Code" | translate) }}</span>
        }

        @if (!claimFromList) {
          <div>
            @if (spinnerAnimation) {
              <div class="spinners">
                <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40"></mat-progress-spinner>
                <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40"></mat-progress-spinner>
              </div>
            }
          </div>
        }

      </ion-button>
    }

    @if (versionPaymentPageData && versionPaymentPageData?.prosubDetail?.content?.[selectedLanguage]?.skip_label) {
      <h1 class="skip-voucher" (click)="skipToCompleteProfilePage()">
        {{ versionPaymentPageData?.prosubDetail?.content?.[selectedLanguage]?.skip_label ?? ("claim-voucher.Skip" | translate) }}
      </h1>
    }

  </ion-content>
} @else {
  <ion-content>

    @if (paymentPageData) {
      <ion-grid style="text-align: center">
        <div [innerHTML]="paymentPageData | safeHtml"></div>
      </ion-grid>
    }

    <h1 class="voucher-header">{{ "claim-voucher.voucher" | translate }}</h1>

    <ion-row>
      <ion-input [ngClass]="isVoucherIsInvalid$.getValue() ? 'invalid-field' : ''" class="action-btn-large voucher-input"
        placeholder="{{'claim-voucher.placeholder' | translate }}" #voucherCode
        (input)="getButtonStatus($event.target.value)" [value]="vc">
      </ion-input>
    </ion-row>

    @if (isVoucherIsInvalid$.getValue()) {
      <ion-row class="voucher-error">
        <p><i class="fas fa-exclamation-triangle"></i> {{ isVoucherIsInvalid$.getValue() }}</p>
      </ion-row>
    }

    <ion-button expand="block" color="secondary" class="checkout-4d-btn" type="submit"
      [disabled]="!voucherCode.value || !isOnline"
      (click)="redeemVoucher(voucherCode.value, false, null); startSpinner()">

      @if ((!spinnerAnimation && proceed) || claimFromList) {
        <span>{{ "claim-voucher.Redeem_Code" | translate }}</span>
      }

      @if (!claimFromList) {
        <div>
          @if (spinnerAnimation) {
            <div class="spinners">
              <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40"></mat-progress-spinner>
              <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40"></mat-progress-spinner>
            </div>
          }
        </div>
      }

    </ion-button>

    <h1 class="skip-voucher" (click)="skipToCompleteProfilePage()">
      {{ "claim-voucher.Skip" | translate }}
    </h1>
  </ion-content>
}
